export default __webpack_public_path__ + "images/fa2734985594b08457d6497936bc7f75-halloween_touchpoint_image.webp";